import { map } from 'lodash-es';
import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree';

import { TypedStoreConfig } from '../factories/store';
import { createApiAction } from '@/api/api-action-factory';
import { SCHOOL_TYPE_INFO_ENDPOINT } from '@/api/endpoints';
import { snakeCase } from '@/utils/utils';

import ApplicationStoreInstance from '../application-store';
import SchoolTypesModel, { TypeSchoolTypeProperties } from './models/school-types-model';

const SchoolStore = TypedStoreConfig({
    modelName: 'SchoolStore',
    properties: {
        schoolsInfo: types.maybeNull(SchoolTypesModel),
    },
})
    .actions((self) => ({
        getSchoolsInfo: createApiAction(self, {
            endpoint: SCHOOL_TYPE_INFO_ENDPOINT,
            target: 'schoolsInfo',
        }),
    }))
    .actions((self) => ({
        afterCreate() {
            self.getSchoolsInfo();
        },
    }))
    .views((self) => ({
        getSchoolTypes() {
            const userLocale = snakeCase(
                ApplicationStoreInstance.userLocale
            ) as keyof TypeSchoolTypeProperties;

            const localizedSchoolsTypes: Record<string, string> = {};

            self.schoolsInfo?.types.forEach((locale, schoolType) => {
                localizedSchoolsTypes[schoolType] = locale[userLocale];
            });
            return map(localizedSchoolsTypes, (value, key) => ({
                key,
                value,
            }));
        },
    }));

export type TypeSchoolsInfoStore = Instance<typeof SchoolStore>;

export default SchoolStore;
